var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.game)?_c('router-view',{attrs:{"game":_vm.game,"player-id":_vm.currentPlayerId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }